import { render, staticRenderFns } from "./CreateRequestDetails.vue?vue&type=template&id=77301872&"
import script from "./CreateRequestDetails.vue?vue&type=script&lang=js&"
export * from "./CreateRequestDetails.vue?vue&type=script&lang=js&"
import style0 from "./CreateRequestDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports